import { Transition } from "components/shared/column";
import Loader from "components/shared/loader";
import { mobileAppTypes } from "helpers/enums";
import { paths } from "helpers/paths";
import React, { lazy, Suspense, useEffect, useState } from "react";
import { CustomScroll } from "react-custom-scroll";
import { getDriverDeviceStatistics } from "sources/admin";

const DataItem = lazy(() => import("./dataItem.js"));

const DeviceStatistics = (props) => {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState({});
    const [appType, setAppType] = useState({});

    const getData = (appType) => {
        getDriverDeviceStatistics(appType)
            .then((res) => {
                const resData = {};
                for (const key in res) {
                    resData[key] = Object.keys(res[key]).map((k) => ({ name: k, value: res[key][k] }));
                }
                setData(resData);
            })
            .then(() => setLoading(false));
    };

    useEffect(() => {
        getData();
    }, []);

    const changeAppType = (newAppType) => {
        setLoading(true);
        setAppType(newAppType);
        getData(newAppType);
    };

    const renderHead = () => {
        const { history } = props;
        return (
            <div className="book-list__head">
                <div className="book-show__close close close--sm" onClick={() => history.push(paths.adminDrivers)} />
                <div className="book-show__title">Информация об устройствах</div>
                <div className="d-flex align-items-center">
                    <select
                        className="form-control form-control-sm"
                        onChange={(e) => changeAppType(e.target.value)}
                        value={appType}
                    >
                        <option value="">Все приложения</option>
                        {mobileAppTypes.map((item) => (
                            <option key={item.value} value={item.value}>
                                {item.label}
                            </option>
                        ))}
                    </select>
                </div>
            </div>
        );
    };

    const renderBody = () => {
        return (
            <div className="row pt-3">
                <Suspense fallback={<div className="loading" />}>
                    <DataItem data={data.appVersion} name="Версия приложения" color="#009d9a" />
                </Suspense>
                <Suspense fallback={<div className="loading" />}>
                    <DataItem data={data.model} name="Модель телефона" color="#6929c4" />
                </Suspense>
                <Suspense fallback={<div className="loading" />}>
                    <DataItem data={data.osType} name="Тип ОС" color="#d7658b" />
                </Suspense>
                <Suspense fallback={<div className="loading" />}>
                    <DataItem data={data.osVersion} name="Версия ОС" color="#b28600" />
                </Suspense>
            </div>
        );
    };

    const renderBodyWrap = () => {
        if (loading) {
            return <Loader prefix="absolute-center" />;
        }

        return <CustomScroll heightRelativeToParent="100%">{renderBody()}</CustomScroll>;
    };

    const { match, location, history } = props;
    return (
        <div className="page-content">
            <Transition dir="full" {...{ match, location, history }}>
                <div className="page-book__show book-show">
                    {renderHead()}
                    <div className="book-show__body">{renderBodyWrap()}</div>
                </div>
            </Transition>
        </div>
    );
};

export default DeviceStatistics;
